import { render, staticRenderFns } from "./flight_menu.vue?vue&type=template&id=3ac0c1bc&scoped=true"
import script from "./flight_menu.vue?vue&type=script&lang=js"
export * from "./flight_menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac0c1bc",
  null
  
)

export default component.exports